document.addEventListener("DOMContentLoaded", () => {
  if(window.innerWidth > 750) {
    // 防抖函数
    function debounce(fn, delay) {
      let timer;
      return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    }
  
    // 针对每个 section 初始化轮播
    document.querySelectorAll('.ht-layers.auto-animation')?.forEach(section => {
      const timeGap = parseInt(section.getAttribute('data-gap'));
      const thumbs = section.querySelectorAll('.layers-item');
      const imgList = section.querySelectorAll('.image-box img');
  
      let currentIndex = 0;
      let intervalId;
  
      function showImage(index) {
        let currImg = imgList[index];
        if (currImg?.classList.contains('active')) return;
  
        imgList.forEach(item => {
          item.classList.remove('active');
        });
        currImg?.classList.add('active');
      }
  
      function activeThumb(index) {
        let currThumb = thumbs[index];
        if (currThumb?.classList.contains('active')) return;
  
        thumbs.forEach(item => {
          item.classList.remove('active');
        });
        currThumb?.classList.add('active');
      }
  
      function startAutoPlay() {
        if (intervalId) return;
        intervalId = setInterval(() => {
          currentIndex = (currentIndex + 1) % imgList.length;
          showImage(currentIndex);
          activeThumb(currentIndex);
        }, timeGap);
      }
  
      function stopAutoPlay() {
        clearInterval(intervalId);
        intervalId = null;
      }
  
      // 鼠标交互
      thumbs.forEach((div, index) => {
        const handleMouseEnter = debounce(() => {
          stopAutoPlay();
          currentIndex = index;
          showImage(index);
          activeThumb(index);
        }, 50);
  
        const handleMouseLeave = debounce(() => {
          startAutoPlay();
        }, 50);
  
        div.addEventListener('mouseenter', handleMouseEnter);
        div.addEventListener('mouseleave', handleMouseLeave);
      });
  
      // IntersectionObserver 控制自动轮播
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            startAutoPlay();
          } else {
            stopAutoPlay();
          }
        });
      }, { threshold: 0.5 });
  
      observer.observe(section);
    });
  }
});
